import React, { useEffect, useState } from 'react';
import { Text, Pane, Flex } from '@leverege/ui-elements';
import { connect } from 'react-redux';
import { UserSettings } from '@leverege/ui-redux';
import S from './BillingViewer.css';
import { BillingTotalCard, BillingBreakdownCard } from '../../dashboard/viewer';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
function BillingViewer(props) {
  const [currentMonth, setCurrentMonth] = useState('');
  const [currentYear, setCurrentYear] = useState('');
  const {
    parentItem
  } = props;
  const systemId = parentItem?.data?.systemId;
  const companyId = parentItem.id;
  useEffect(() => {
    const today = new Date();
    setCurrentMonth(today.toLocaleString('default', {
      month: 'long'
    }));
    setCurrentYear(today.getFullYear());
  }, [systemId, companyId]);
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "billingDashboard",
    className: S.container,
    children: [/*#__PURE__*/_jsxs(Text, {
      variant: "billingDashboardTitle",
      children: ["Month of ", currentMonth, " ", currentYear]
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "billingDashboard",
      className: S.billingDashboard,
      children: [/*#__PURE__*/_jsx(BillingTotalCard, {
        ...props
      }), /*#__PURE__*/_jsx(BillingBreakdownCard, {
        ...props
      })]
    })]
  });
}
export default connect((state, props) => ({
  filterModel: UserSettings.get(state, props.settingsPath, {
    returnPromise: false
  })
}))(BillingViewer);